import { Box } from '@mui/material'
import { Separator } from 'react-resizable-panels'

const PanelSeparator = () => {
  return (
    <Separator
      className='resize-handle'
      style={{
        width: '1rem',
        cursor: 'col-resize',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        outline: 'none'
      }}
    >
      <Box
        sx={{
          width: '3px',
          height: '3rem',
          backgroundColor: (theme) => theme.palette.divider,
          borderRadius: '3px',
          transition: 'all 0.2s ease-in-out',

          '.resize-handle:hover &, .resize-handle[data-resize-handle-active] &': {
            backgroundColor: 'primary.main',
            height: '4.5rem',
            width: '4px'
          }
        }}
      />
    </Separator>
  )
}

export default PanelSeparator
